import React, { useEffect, useState } from 'react';
import PurchaseGiftCardForSelf from '../components/PurchaseGiftCardForSelf';
import PurchaseGiftCardForOthers from '../components/PurchaseGiftCardForOthers';
import BadgeOptions from '../components/BadgeOptions';
import { OrderingConstants, OrderingOperations, OrderingSelectors } from 'polygon-ordering';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { styled } from '@mui/system';
import { useTyro } from '../hooks/TyroProvider';
import { purchaseGiftCardClicked } from '../utils/analytics';

const { getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES } = OrderingConstants;

const BadgeOptionsWrapper = styled('div')(() => {
  return {
    '.row': {
      margin: '10px 0 1.5em',
    },
  };
});

const { fetchGiftcardSurcharge } = OrderingOperations;

const PurchaseGiftCardScreen = () => {
  const [gift, setGift] = useState(true);
  const dispatch = useAppDispatch();
  const gatewayType = useAppSelector(getGatewayType);
  // eslint-disable-next-line
  const tyroData = gatewayType === PAYMENT_GATEWAY_TYPES.TYRO ? useTyro() : null;
  const { resetPaySecret, setGiftCardTopUpData } =
    gatewayType === PAYMENT_GATEWAY_TYPES.TYRO && tyroData;

  useEffect(() => {
    dispatch(fetchGiftcardSurcharge());
    purchaseGiftCardClicked();
  }, []);

  return (
    <div>
      <BadgeOptionsWrapper>
        <BadgeOptions
          active={gift}
          setActive={status => {
            setGift(status);
            if (gatewayType === PAYMENT_GATEWAY_TYPES.TYRO) {
              resetPaySecret();
            }
            setGiftCardTopUpData(null);
          }}
          activeKey="buyAsGift"
          inactiveKey="buyForMyself"
        />
      </BadgeOptionsWrapper>

      {gift ? <PurchaseGiftCardForOthers /> : <PurchaseGiftCardForSelf />}
    </div>
  );
};

export default PurchaseGiftCardScreen;
